import { createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../../app/store";

export interface LoadingProgressState {
  status: number;
}

const initialState: LoadingProgressState = {
  status: 0,
};

export const LoadingProgress = createSlice({
  name: "loadingProgress",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    startLoading: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.status = 1;
    },
    endLoading: (state) => {
      state.status = 0;
    },
  },
});

export const { startLoading, endLoading } = LoadingProgress.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectLoadingProgressStatus = (state: RootState) =>
  state.loadingProgress?.status;

export default LoadingProgress.reducer;
